import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=f388d1d4&scoped=true"
import script from "./addRole.vue?vue&type=script&lang=js"
export * from "./addRole.vue?vue&type=script&lang=js"
import style0 from "./addRole.vue?vue&type=style&index=0&id=f388d1d4&prod&lang=css"
import style1 from "./addRole.vue?vue&type=style&index=1&id=f388d1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f388d1d4",
  null
  
)

export default component.exports